import { Loader } from "./deps/esbuild-wasm.ts";
import { basename, extname } from "./deps/path.ts";

const loaderList: Loader[] = [
  "base64",
  "binary",
  "copy",
  "css",
  "dataurl",
  "default",
  "empty",
  "file",
  "js",
  "json",
  "jsx",
  "local-css",
  "text",
  "ts",
  "tsx",
];
const isLoader = (loader: string): loader is Loader =>
  (loaderList as string[]).includes(loader);

export const isLoaderWhichCanIncludeSourceMappingURL = (
  loader: Loader,
): boolean => /^js|^ts|css$/.test(loader);

export const responseToLoader = (response: Response): Loader => {
  const url = response.url;
  const filename = basename(url);
  if (isLoader(filename)) return filename;
  if (filename === "mjs") return "js";
  // remove query string and hash fragment
  const pure = new URL(url);
  pure.search = "";
  pure.hash = "";
  const ext = extname(pure.href).slice(1);
  if (isLoader(ext)) return ext;
  if (ext === "mjs") return "js";
  const contentType = response.headers.get("Content-Type") ?? "text/plain";
  const mimeType = contentType.split(";")[0]?.trim?.() ?? "text/plain";
  return mimeTypeToLoader(mimeType);
};

export const mimeTypeToLoader = (mimeType: string): Loader => {
  const subType = mimeType.split("/")[1] ?? "plain";
  if (/(?:^plain$|^xml|^svg|^x?html)/.test(subType)) {
    return "text";
  }
  if (subType.startsWith("json")) {
    return "json";
  }
  switch (subType) {
    case "javascript":
      return "js";
    case "typescript":
      return "ts";
    case "css":
      return "css";
    default:
      return "text";
  }
};

// denoCacheMetadata={"headers":{"cross-origin-resource-policy":"cross-origin","x-xss-protection":"1; mode=block","cache-control":"max-age=300","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","etag":"W/\"f4e6625ff5a96b283f5dfae74e94d33a60aa73150de67dbe45ba562cdc33fd30\"","date":"Fri, 08 Nov 2024 10:10:00 GMT","x-github-request-id":"B05C:1E0811:132AFE7:14E54DD:672DDE08","x-served-by":"cache-iad-kcgs7200100-IAD","x-timer":"S1731060601.757503,VS0,VE2","x-content-type-options":"nosniff","expires":"Fri, 08 Nov 2024 10:15:00 GMT","strict-transport-security":"max-age=31536000","content-type":"text/plain; charset=utf-8","source-age":"90","accept-ranges":"bytes","via":"1.1 varnish","x-cache-hits":"0","vary":"Authorization,Accept-Encoding,Origin","x-cache":"HIT","access-control-allow-origin":"*","x-fastly-request-id":"f8454392dc015f19bbe885bb327d1d3d0dc50e23","x-frame-options":"deny"},"url":"https://raw.githubusercontent.com/takker99/ScrapJupyter/v1.7.4/loader.ts","time":1731060600}